module.exports = __webpack_public_path__ + "46e0b9c2d058d11da8704c7581bea859.svg";